export const inspectionReport = {
  vehicle: "Vehicle",
  fleet: "Fleet",
  uninspected: "Uninspected",
  passed: "Passed",
  criticalItemFailed: "Critical Item Failed",
  nonCriticalItemFailed: "Non-Critical Item Failed",
  make: "Make",
  model: "Model",
  reliability: "Reliability",
  submittedAt: "Submitted at",
  submittedBy: "Submitted by",
  InspectionNotes: "Inspection Notes",
  Notes: "Notes",
  inspected: "Inspected",
};
